export const SEARCH_PRODUCTS_REQUEST = "SEARCH_PRODUCTS_REQUEST";
export const SEARCH_PRODUCTS_SUCCESS = "SEARCH_PRODUCTS_SUCCESS";
export const SEARCH_PRODUCTS_FAIL = "SEARCH_PRODUCTS_FAIL";
export const INC_SEARCH_PAGE = "INC_SEARCH_PAGE";
export const SET_SEARCH_PAGE = "SET_SEARCH_PAGE";
export const RESET_SEARCH_PAGE = "RESET_SEARCH_PAGE";
export const TRIGGER_REFRESHING = "TRIGGER_REFRESHING";
export const SET_SEARCH_PAGE_COUNT = "SET_SEARCH_PAGE_COUNT";
export const RESET_SEARCH_PAGE_COUNT = "RESET_SEARCH_PAGE_COUNT";
